/**
 * 全文表示テキスト
 *
 * テーブルのセルなどで、利用者が入力した自由記述（特記事項・備考など）を省略せずに表示する。
 * - 入力時の改行をそのまま表示する（white-space: pre-wrap）
 * - 空白を含まない長い英数字（URL など）もセル幅で折り返す（overflow-wrap: anywhere。
 *   未対応の古いブラウザ（iOS Safari 15.3 以前など）向けに word-break: break-word も指定する）
 *
 * 背景: テーブル列の ellipsis や行数制限で途中から省略され、全文をどこにも表示できない箇所があった。
 */

/** 省略せずに折り返して表示するためのスタイル */
const FULL_TEXT_STYLE: React.CSSProperties = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  overflowWrap: 'anywhere',
};

interface Props {
  /** 表示する文字列（未入力は null） */
  readonly text: string | null;
  /** 未入力（null・空文字）のときに表示する文字列 */
  readonly emptyPlaceholder: string;
}

export const FullText: React.FC<Props> = ({ text, emptyPlaceholder }) => {
  if (text === null || text === '') {
    return <>{emptyPlaceholder}</>;
  }
  return <span style={FULL_TEXT_STYLE}>{text}</span>;
};
